import React from 'react';

import {StageConfiguration, WorkflowStage} from 'workflows/WorkflowConstants';

import StageMenu from './StageMenu';

function StageHeaderCell(props: StageHeaderCellProps): JSX.Element {
  return (
    <div className="workflowDetailsTable-stageHeaderCell">
      <div
        className="stageHeaderCell-name"
        onClick={(e) => {
          props.onSetIsStageCollapsed(!props.isStageCollapsed);
        }}
      >
        {props.workflowStage.name}
      </div>
      {props.workflowStage.permissions.writable && <StageMenu {...props} />}
    </div>
  );
}

interface StageHeaderCellProps {
  baseWorkflowTemplateVersionId: string | null;
  onBulkCreateStageRuns: (stageConfiguration: StageConfiguration) => void;
  onBulkSplitStageRuns: (workflowStage: WorkflowStage) => void;
  onCreate: (workflowStage: WorkflowStage) => void;
  onSetIsStageCollapsed: (newIsStageCollapsed: boolean) => void;
  isStageCollapsed: boolean;
  stageConfiguration: StageConfiguration;
  workflowStage: WorkflowStage;
}

export default StageHeaderCell;
